import { createContext } from 'react';
import { ICaseDetails } from '../../../../interfaces/cases';

export const CaseDetailsContext = createContext<ICaseDetails | undefined>(
  undefined
);
